(function () {
    // slide trang chủ
    var galleryThumbs = new Swiper('.gallery-thumbs', {
        slidesPerView: 6,
        spaceBetween: 10,
        loop: true,
        freeMode: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loopedSlides: 6, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.gallery-top', {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loopedSlides: 6, //looped slides should be the same
        thumbs: {
            swiper: galleryThumbs,
        },
    });

    // artist trang chủ
    var galleryThumbsArtist = new Swiper('.gallery-thumbs-artist', {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: false,
        freeMode: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loopedSlides: 4, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });
    var galleryTopArtist = new Swiper('.gallery-top-artist', {
        loop: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loopedSlides: 4, //looped slides should be the same
        thumbs: {
            swiper: galleryThumbsArtist
        },
    });

    // nghe gì hôm nay home
    var galleryToday = new Swiper('.gallery-today', {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        breakpoints: {
            1600: {
                slidesPerView: 5,
            },
            1440: {
                slidesPerView: 5,
            },
            1150: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3,
            },

            320: {
                slidesPerView: 3,
            }
        }
    });

    // Mới phát hành trang chủ
    var gallerySongNew = new Swiper('.gallery-song-new', {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        breakpoints: {
            1600: {
                slidesPerView: 5,
            },
            1440: {
                slidesPerView: 5,
            },
            1150: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3,
            },

            320: {
                slidesPerView: 3,
            }
        }
    });
    // Playlist/Album
    var galleryPlaylistAlbum = new Swiper('.gallery-playlist-album', {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        breakpoints: {
            1600: {
                slidesPerView: 5,
            },
            1440: {
                slidesPerView: 5,
            },
            1150: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3,
            },

            320: {
                slidesPerView: 3,
            }
        }
    });

    /// Playlist hot nhất

    var galleryNewRelease = new Swiper('.gallery__new-release', {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        breakpoints: {
            1600: {
                slidesPerView: 5,
            },
            1440: {
                slidesPerView: 5,
            },
            1150: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3,
            },

            320: {
                slidesPerView: 3,
            }
        }
    });

    // Video MV

    var galleryVideoMv = new Swiper('.gallery__video-mv', {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        breakpoints: {
            1600: {
                slidesPerView: 5,
            },
            1440: {
                slidesPerView: 5,
            },
            1150: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3,
            },

            320: {
                slidesPerView: 3,
            }
        }
    });
})(jQuery);
